import React from "react";
import { Dropdown } from "@fluentui/react";
import { useField } from "formik";

const DropDown = (props) => {
  const [field, meta, helpers] = useField(props);
  const selectedKeys = field.value || [];

  const onChange = (event, item) => {
    helpers.setValue(item.key);
  };

  const onChangeMultiSelect = (event, item) => {
    let keys = selectedKeys;

    if (item) {
      keys = item.selected ? [...selectedKeys, item.key] : selectedKeys.filter((key) => key !== item.key)
      helpers.setValue(keys);
    }

    if (props.handleChangeMultiSelect) {
        props.handleChangeMultiSelect(event, item, keys);
    }
  };

  return (
    <Dropdown
      {...field}
      selectedKey={!props.multiSelect && field.value || null}
      selectedKeys={props.multiSelect && field.value}
      errorMessage={meta.touched && meta.error}
      onDismiss={() => helpers.setTouched(true)}
      onChange={props.multiSelect ? onChangeMultiSelect : onChange}
      {...props}
    />
  );
};

export default DropDown;
